import googleTagLinkerMin from '@giovaniortolanibarbosa/google-tag-linker';

import { memoizedCartRedirectUrl } from '@/helpers/big-commerce';
import { triggerAddToCart } from '@/helpers/gtm';
import { useCartOperations } from '@/helpers/hooks/use-cart-operations';

// import { useCart } from '@/helpers/shopify/cart';

export const findCartLineVariant = (line) => {
  return line.node.merchandise.product.variants.edges.find((item) => {
    return item.node.id === line.node.merchandise.id;
  })?.node;
};

const decorateUrl = (href) => {
  const url = new URL(href);

  const linkerParam = googleTagLinkerMin('get');
  if (typeof linkerParam === 'string') {
    url.searchParams.set('_gl', linkerParam);
  }

  return url.href;
};

export const useCartActions = () => {
  // const [cart, cartActions] = useCart();
  const { createCart } = useCartOperations();

  /**
   * @typedef AddItemsResult
   * @type {Object}
   * @property {Object} cart
   */

  /**
   * @param {Array<Object>} items
   * @returns {Promise<AddItemsResult>}
   */
  // const addItems = async (items) => {
  //   const lines = items.map((item) => {
  //     return {
  //       merchandiseId: item.variant.id,
  //       quantity: item.quantity,
  //     };
  //   });

  //   let result;

  //   let cartId = cart.id;
  //   if (!cartId) {
  //     const { data } = await createCart({
  //       variables: {
  //         lineItems: lines,
  //       },
  //     });

  //     cartId = data.cartCreate.cart.id;
  //     cartActions?.setId?.(data.cartCreate.cart.id);

  //     result = {
  //       cart: data.cartCreate.cart,
  //     };
  //   } else {
  //     const { data } = await addToCart({
  //       variables: {
  //         cartId,
  //         lines,
  //       },
  //     });

  //     result = {
  //       cart: data.cartLinesAdd.cart,
  //     };
  //   }

  //   items.forEach((item) => {
  //     triggerAddToCart(item);

  //     sendShopifyAddToCartAnalytics({
  //       ...item,
  //       hasUserConsent,
  //       cartId,
  //     });
  //   });

  //   return result;
  // };

  /**
   * @param {Object} params
   * @returns {Promise<Object>}
   */
  const buyNow = async ({ lines }) => {
    lines.forEach((item) => {
      triggerAddToCart({
        product: item.product,
        variant: item.variant || null,
        quantity: item.quantity,
      });
    });

    const { data } = await createCart({
      variables: {
        createCartInput: {
          lineItems: lines.map(({ product, variant, quantity }) => ({
            productEntityId: parseInt(product?.entityId, 10),
            variantEntityId: parseInt(variant?.entityId, 10),
            quantity,
          })),
        },
      },
    });

    const cart = data.cart.createCart.cart;

    const redirectUrl = await memoizedCartRedirectUrl(cart.entityId);

    // cartActions?.setId?.(cart.id);

    // items.forEach((item) => {
    //   triggerAddToCart(item);
    // });

    window.location.href = decorateUrl(redirectUrl?.data?.checkout_url);

    return {
      cart,
    };
  };

  // const removeItem = async ({ line, shopifyProduct, variant, quantity }) => {
  //   if (cart.id) {
  //     await removeFromCart({
  //       variables: {
  //         cartId: cart.id,
  //         lineIds: [line.node.id],
  //       },
  //     });

  //     triggerRemoveFromCart({
  //       shopifyProduct,
  //       variant,
  //       quantity,
  //     });
  //   }
  // };

  // const updateItemQuantity = async ({ line, quantity }) => {
  //   if (cart.id) {
  //     const shopifyProduct = line.node.merchandise.product;
  //     const variant = findCartLineVariant(line);

  //     const lines = [
  //       {
  //         id: line.node.id,
  //         merchandiseId: variant.id,
  //         quantity,
  //       },
  //     ];

  //     await editCartItems({
  //       variables: {
  //         cartId: cart.id,
  //         lines,
  //       },
  //     });

  //     const difference = quantity - line.node.quantity;

  //     if (difference > 0) {
  //       triggerAddToCart({
  //         shopifyProduct,
  //         variant,
  //         quantity: difference,
  //       });
  //     } else if (difference < 0) {
  //       triggerRemoveFromCart({
  //         shopifyProduct,
  //         variant,
  //         quantity: -difference,
  //       });
  //     }
  //   }
  // };

  return { buyNow };
};
